/**
 * Wize Mobile API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { ErrorResponse } from '../model/errorResponse';
// @ts-ignore
import { OrderDetail } from '../model/orderDetail';
// @ts-ignore
import { OrderList } from '../model/orderList';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class GeneralOrderMobileAPIService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Order detail by ID
     * @param orderId orderId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getOrderDetail(orderId: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<OrderDetail>;
    public getOrderDetail(orderId: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<OrderDetail>>;
    public getOrderDetail(orderId: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<OrderDetail>>;
    public getOrderDetail(orderId: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (orderId === null || orderId === undefined) {
            throw new Error('Required parameter orderId was null or undefined when calling getOrderDetail.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/restful/api/mobile/orders/v1/orders/${this.configuration.encodeParam({name: "orderId", value: orderId, in: "path", style: "simple", explode: false, dataType: "number", dataFormat: "int64"})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<OrderDetail>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * List of orders based on selection criteria
     * @param beginDate beginDate
     * @param endDate endDate
     * @param portfolioIds portfolioIds
     * @param domain domain - comma-separated values for multiple domains
     * @param orderStatus orderStatus - comma-separated values for multiple statuses
     * @param onlyInvestDisinvest onlyInvestDisinvest
     * @param securityId securityId
     * @param accountId accountId
     * @param maxResults maxResults
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listOrders(beginDate: string, endDate: string, portfolioIds?: Array<string>, domain?: string, orderStatus?: string, onlyInvestDisinvest?: boolean, securityId?: string, accountId?: string, maxResults?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<Array<OrderList>>;
    public listOrders(beginDate: string, endDate: string, portfolioIds?: Array<string>, domain?: string, orderStatus?: string, onlyInvestDisinvest?: boolean, securityId?: string, accountId?: string, maxResults?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<Array<OrderList>>>;
    public listOrders(beginDate: string, endDate: string, portfolioIds?: Array<string>, domain?: string, orderStatus?: string, onlyInvestDisinvest?: boolean, securityId?: string, accountId?: string, maxResults?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<Array<OrderList>>>;
    public listOrders(beginDate: string, endDate: string, portfolioIds?: Array<string>, domain?: string, orderStatus?: string, onlyInvestDisinvest?: boolean, securityId?: string, accountId?: string, maxResults?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (beginDate === null || beginDate === undefined) {
            throw new Error('Required parameter beginDate was null or undefined when calling listOrders.');
        }
        if (endDate === null || endDate === undefined) {
            throw new Error('Required parameter endDate was null or undefined when calling listOrders.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (portfolioIds) {
            portfolioIds.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'portfolioIds');
            })
        }
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>domain, 'domain');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>orderStatus, 'orderStatus');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>onlyInvestDisinvest, 'onlyInvestDisinvest');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>beginDate, 'beginDate');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>endDate, 'endDate');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>securityId, 'securityId');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>accountId, 'accountId');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>maxResults, 'maxResults');

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/restful/api/mobile/orders/v1/orders`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<OrderList>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Paginated feed of orders based on selection criteria, ordered by operation date descending
     * @param portfolioIds portfolioIds
     * @param domain domain - comma-separated values for multiple domains
     * @param orderStatus orderStatus - comma-separated values for multiple statuses
     * @param onlyInvestDisinvest onlyInvestDisinvest
     * @param beginDate beginDate - optional, defaults to a configurable lookback window before endDate
     * @param endDate endDate - optional, defaults to today
     * @param securityId securityId
     * @param accountId accountId
     * @param page page (0-based)
     * @param pageSize pageSize
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listOrdersFeed(portfolioIds?: Array<string>, domain?: string, orderStatus?: string, onlyInvestDisinvest?: boolean, beginDate?: string, endDate?: string, securityId?: string, accountId?: string, page?: number, pageSize?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<Array<OrderList>>;
    public listOrdersFeed(portfolioIds?: Array<string>, domain?: string, orderStatus?: string, onlyInvestDisinvest?: boolean, beginDate?: string, endDate?: string, securityId?: string, accountId?: string, page?: number, pageSize?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<Array<OrderList>>>;
    public listOrdersFeed(portfolioIds?: Array<string>, domain?: string, orderStatus?: string, onlyInvestDisinvest?: boolean, beginDate?: string, endDate?: string, securityId?: string, accountId?: string, page?: number, pageSize?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<Array<OrderList>>>;
    public listOrdersFeed(portfolioIds?: Array<string>, domain?: string, orderStatus?: string, onlyInvestDisinvest?: boolean, beginDate?: string, endDate?: string, securityId?: string, accountId?: string, page?: number, pageSize?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (portfolioIds) {
            portfolioIds.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'portfolioIds');
            })
        }
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>domain, 'domain');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>orderStatus, 'orderStatus');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>onlyInvestDisinvest, 'onlyInvestDisinvest');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>beginDate, 'beginDate');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>endDate, 'endDate');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>securityId, 'securityId');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>accountId, 'accountId');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>page, 'page');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageSize, 'pageSize');

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/restful/api/mobile/orders/v1/orders/feed`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<OrderList>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * List of stock market orders based on selection criteria
     * @param beginDate beginDate
     * @param endDate endDate
     * @param portfolioIds portfolioIds
     * @param orderStatus orderStatus - comma-separated values for multiple statuses
     * @param onlyInvestDisinvest onlyInvestDisinvest
     * @param securityId securityId
     * @param page page (0-based)
     * @param pageSize pageSize
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listStockMarketOrders(beginDate: string, endDate: string, portfolioIds?: Array<string>, orderStatus?: string, onlyInvestDisinvest?: boolean, securityId?: string, page?: number, pageSize?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<Array<OrderList>>;
    public listStockMarketOrders(beginDate: string, endDate: string, portfolioIds?: Array<string>, orderStatus?: string, onlyInvestDisinvest?: boolean, securityId?: string, page?: number, pageSize?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpResponse<Array<OrderList>>>;
    public listStockMarketOrders(beginDate: string, endDate: string, portfolioIds?: Array<string>, orderStatus?: string, onlyInvestDisinvest?: boolean, securityId?: string, page?: number, pageSize?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<HttpEvent<Array<OrderList>>>;
    public listStockMarketOrders(beginDate: string, endDate: string, portfolioIds?: Array<string>, orderStatus?: string, onlyInvestDisinvest?: boolean, securityId?: string, page?: number, pageSize?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext}): Observable<any> {
        if (beginDate === null || beginDate === undefined) {
            throw new Error('Required parameter beginDate was null or undefined when calling listStockMarketOrders.');
        }
        if (endDate === null || endDate === undefined) {
            throw new Error('Required parameter endDate was null or undefined when calling listStockMarketOrders.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        if (portfolioIds) {
            portfolioIds.forEach((element) => {
                localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
                  <any>element, 'portfolioIds');
            })
        }
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>orderStatus, 'orderStatus');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>onlyInvestDisinvest, 'onlyInvestDisinvest');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>beginDate, 'beginDate');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>endDate, 'endDate');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>securityId, 'securityId');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>page, 'page');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageSize, 'pageSize');

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/restful/api/mobile/orders/v1/orders/stockmarket`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<OrderList>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
